"use client";

import { Link } from "@/i18n/routing";
import { Icon } from "@iconify/react";

export interface BreadcrumbItem {
  label: string;
  href: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

export function Breadcrumb({ items, className = "" }: BreadcrumbProps) {
  // Don't show breadcrumb if there's only home or home + one item (top-level pages)
  if (items.length <= 2) {
    return null;
  }

  return (
    <nav
      aria-label="Breadcrumb"
      className={`mb-4 flex justify-end ${className}`}
    >
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-primary/60">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li key={item.href} className="flex items-center gap-1.5">
              {index > 0 && (
                <Icon
                  icon="solar:alt-arrow-right-linear"
                  className="h-3.5 w-3.5 text-tertiary"
                  aria-hidden="true"
                />
              )}
              {isLast ? (
                <span className="font-medium text-primary" aria-current="page">
                  {item.label}
                </span>
              ) : (
                <Link
                  href={item.href}
                  className="text-tertiary hover:text-[var(--gold)] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--gold)] focus-visible:ring-offset-2 rounded-sm px-1 -mx-1"
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
